import { get, isNil } from 'lodash';

const getAnyOrVoid = (path, root) => {
  const found = get(root, path);
  return isNil(found) ? void 1 : found;
};

// noinspection JSUnusedGlobalSymbols
export default getAnyOrVoid;
